module.exports = __webpack_public_path__ + "DINNextLTPro-UltraLightCond.woff2?35752ca856de96d08433482e8dac7258";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/DINNextLTPro-UltraLightCond.woff2
// module id = 1385
// module chunks = 0